/* eslint-disable no-underscore-dangle */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import {
  DEBOUNCE_DELAY,
  alertTypes,
  initialMetaForTable,
} from 'constants/Common'
import { deleteEvent, getEvents } from 'containers/events/Api'
import React, { useEffect, useState } from 'react'
import { PencilSimple, Trash } from 'phosphor-react'
import ClockIcon from 'assets/images/shell/icon-clock.svg'
import PinIcon from 'assets/images/shell/icon-pin.svg'
import UsersIcon from 'assets/images/shell/icon-users.svg'
import PublicIcon from 'assets/images/shell/chip-public.svg'
import AddIcon from 'assets/images/shell/icon-add.svg'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
// import { EVENT_DOWNLOAD } from 'constants/EndPoints'
import { get } from 'services/network'
import EventDelete from './EventDeleteModal'

let timeout
function EventsListing() {
  const [eventsList, setEventsList] = useState([])
  const [loading, setLoading] = useState(false)
  const [meta, setMeta] = useState({ ...initialMetaForTable })
  const [refresh, setRefresh] = useState(false)
  const [isEventDeleteModalVisible, setIsEventDeleteModalVisible] =
    useState(false)
  const [selectedEvent, setSelectedEvent] = useState()

  const navigate = useNavigate()
  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }
  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value }))
    handleRefresh()
  }
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value, page: 1 }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }
  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }
  const getEventEndMoment = (event) => {
    const startMoment = moment(event?.startDate)
    if (event?.endDate) {
      return moment(event.endDate)
    }
    return startMoment.clone().add(1, 'hour')
  }

  const getEventClockLabel = (event) => {
    const startMoment = moment(event?.startDate)
    const endMoment = event?.endDate ? moment(event.endDate) : null

    if (!startMoment.isValid()) return 'Time not available'
    if (endMoment?.isValid()) {
      return `${startMoment.format('HH:mm')} - ${endMoment.format('HH:mm')}`
    }

    return startMoment.format('HH:mm')
  }

  const getEventStatus = (event) => {
    const now = moment()
    const startMoment = moment(event?.startDate)
    const endMoment = getEventEndMoment(event)

    if (now.isBetween(startMoment, endMoment, undefined, '[]')) {
      return 'Live Now'
    }
    if (now.isAfter(endMoment)) {
      return 'Completed'
    }
    return 'Upcoming'
  }

  const getEventType = (event) =>
    event?.category?.name ||
    event?.eventType ||
    event?.type ||
    event?.track ||
    'Session'

  const getRenderableText = (value, fallback = 'N/A') => {
    if (value === null || value === undefined) return fallback
    if (typeof value === 'string' || typeof value === 'number') {
      const normalized = String(value).trim()
      return normalized || fallback
    }
    return fallback
  }

  const getStatusClassName = (status) => {
    if (status === 'Live Now') return 'event-chip event-chip--live'
    if (status === 'Completed') return 'event-chip event-chip--completed'
    return 'event-chip event-chip--upcoming'
  }

  const getCategoryClassName = (category) => {
    const label = String(category).toLowerCase()
    if (label.includes('keynote')) return 'event-chip event-chip--keynote'
    if (label.includes('workshop')) return 'event-chip event-chip--workshop'
    if (label.includes('breakout')) return 'event-chip event-chip--breakout'
    return 'event-chip event-chip--category'
  }

  const getAttendeeCount = (event) => {
    if (event?.attendeesCount) return event.attendeesCount
    if (event?.attendeeCount) return event.attendeeCount
    if (event?.attendees?.length) return event.attendees.length
    if (event?.registeredCount) return event.registeredCount
    return 0
  }

  const getCapacityCount = (event) =>
    event?.seatsCount ||
    event?.capacity ||
    event?.maxAttendees ||
    event?.maxCapacity ||
    event?.seats ||
    null

  const getEventSlug = (name) =>
    String(name || 'event')
      .replace(/[\u200B-]/g, '')
      .trim()
      .split(/[\s–-]+/)
      .join('-')

  const fetchEvents = async () => {
    setLoading(true)
    const result = await getEvents(meta.page, meta.perPage, meta.search)
    if (result?.LastPage && result?.Total) {
      const resultMeta = result
      setMeta((pre) => ({
        ...pre,
        totalCount: resultMeta.Total,
        totalPages: resultMeta.LastPage,
      }))
    }
    if (result?.data) {
      const { data } = result
      setEventsList(data)
    }
    setLoading(false)
  }
  const handleAddEvent = () => {
    navigate('/events/create')
  }

  const handleCloseEventDeleteModal = () => {
    setIsEventDeleteModalVisible(false)
    setSelectedEvent()
  }
  const handleOpenDeleteEventModal = () => {
    setIsEventDeleteModalVisible(true)
  }
  const handleDeleteEvent = async () => {
    // eslint-disable-next-line no-underscore-dangle
    console.log(selectedEvent)
    const result = await deleteEvent(selectedEvent._id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Event Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseEventDeleteModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const downloadExcel = async (event) => {
    try {
      const response = await get(
        `${process.env.REACT_APP_API_URL}event/export/${event._id}`,
        true,
        null,
        null,
        {
          responseType: 'blob',
          headers: {
            Accept: 'text/csv',
          },
        }
      )

      const link = document.createElement('a')
      link.href = URL.createObjectURL(response)
      link.download = event.name || 'Export'
      link.click()
      return true
    } catch (error) {
      console.error(error)
      return error
    }
  }

  useEffect(() => {
    fetchEvents()
  }, [refresh])

  const normalizedSearch = String(meta.search || '')
    .trim()
    .toLowerCase()
  const filteredEventsList = normalizedSearch
    ? eventsList.filter((event) =>
        String(event?.name || '')
          .toLowerCase()
          .includes(normalizedSearch)
      )
    : eventsList

  return (
    <div className='event-main'>
      <div className='container-fluid'>
        <TableWrapper
          eventFilterHeader
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={
            normalizedSearch ? filteredEventsList.length : meta.totalCount
          }
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          searchPlaceholder='Search...'
          actionButtons={[
            {
              label: '',
              icon: <img src={AddIcon} width={20} height={20} alt='' />,
              handleClick: handleAddEvent,
              classes: 'filter-add-btn',
              ariaLabel: 'Add event',
            },
          ]}
        >
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <div className='events-card-grid'>
              {!filteredEventsList?.length && (
                <p className='events-card-grid__empty'>No events found.</p>
              )}
              {filteredEventsList?.map((item) => {
                const status = getEventStatus(item)
                const category = getRenderableText(getEventType(item), 'Session')
                const attendees = getAttendeeCount(item)
                const capacity = getCapacityCount(item)
                const locationName = getRenderableText(
                  item?.location?.address || item?.location,
                  'TBA'
                )
                const eventTitle = getRenderableText(item?.name, 'Untitled Event')
                const bannerImage =
                  item?.photo?.[0]?.link ||
                  item?.gallery?.[0]?.imageUrl ||
                  item?.coverImage ||
                  item?.bannerImage ||
                  item?.image ||
                  item?.thumbnail
                const speakerInitials = (item?.speakers || [])
                  .map((speaker) =>
                    String(speaker?.name || speaker?.fullName || '')
                      .trim()
                      .charAt(0)
                      .toUpperCase()
                  )
                  .filter(Boolean)
                const visibleInitials = speakerInitials.slice(0, 3)
                const extraSpeakers = Math.max(speakerInitials.length - 3, 0)

                return (
                  <article className='event-card' key={item._id || item.id}>
                    <div className='event-card__media'>
                      {bannerImage ? (
                        <img
                          src={bannerImage}
                          alt={eventTitle}
                          className='event-card__media-image'
                        />
                      ) : (
                        <div className='event-card__media-fallback' />
                      )}
                      <div className='event-card__chips'>
                        {status === 'Live Now' && (
                          <span className={getStatusClassName(status)}>
                            <span className='event-chip__dot' />
                            {status}
                          </span>
                        )}
                        <span className={getCategoryClassName(category)}>
                          {category}
                        </span>
                        <span className='event-chip event-chip--public'>
                          <img src={PublicIcon} width={12} height={12} alt='' />
                          Public
                        </span>
                      </div>
                    </div>

                    <div className='event-card__body'>
                      <h3 className='event-card__title' title={item?.name}>
                        {eventTitle}
                      </h3>

                      <div className='event-card__meta-list'>
                        <div className='event-card__meta-row'>
                          <img src={ClockIcon} width={14} height={14} alt='' />
                          <p className='event-card__meta'>
                            {getEventClockLabel(item)}
                          </p>
                        </div>
                        <div className='event-card__meta-row'>
                          <img src={PinIcon} width={14} height={14} alt='' />
                          <p className='event-card__meta event-card__meta--link'>
                            {locationName}
                          </p>
                        </div>
                        <div className='event-card__meta-row'>
                          <img src={UsersIcon} width={14} height={14} alt='' />
                          <p className='event-card__meta'>
                            {capacity
                              ? `${attendees}/${capacity} attendees`
                              : `${attendees} attendees`}
                          </p>
                        </div>
                      </div>

                      <div className='event-card__footer'>
                        <div className='event-card__avatars'>
                          {visibleInitials.map((initial, index) => (
                            <span
                              className={`event-card__avatar event-card__avatar--${index}`}
                              key={`${item._id}-${initial}-${index}`}
                            >
                              {initial}
                            </span>
                          ))}
                          {extraSpeakers > 0 && (
                            <span className='event-card__avatar-more'>
                              +{extraSpeakers}
                            </span>
                          )}
                        </div>
                        <div className='event-card__footer-actions'>
                          <button
                            type='button'
                            className='event-card__icon-btn'
                            aria-label='Edit event details'
                            onClick={() => {
                              navigate(`/events/${item._id}/edit`)
                            }}
                          >
                            <PencilSimple size={16} />
                          </button>
                          <button
                            type='button'
                            className='event-card__icon-btn'
                            aria-label='Delete event'
                            onClick={() => {
                              setSelectedEvent(item)
                              handleOpenDeleteEventModal()
                            }}
                          >
                            <Trash size={16} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                )
              })}
            </div>
          )}
        </TableWrapper>
      </div>
      {isEventDeleteModalVisible && (
        <EventDelete
          handleDeleteUser={handleDeleteEvent}
          handleCloseModal={handleCloseEventDeleteModal}
        />
      )}
    </div>
  )
}

export default EventsListing
